import { render, staticRenderFns } from "./ChildParamsSortOrder.vue?vue&type=template&id=774b494e&scoped=true"
import script from "./ChildParamsSortOrder.vue?vue&type=script&lang=js"
export * from "./ChildParamsSortOrder.vue?vue&type=script&lang=js"
import style0 from "./ChildParamsSortOrder.vue?vue&type=style&index=0&id=774b494e&prod&lang=css"
import style1 from "./ChildParamsSortOrder.vue?vue&type=style&index=1&id=774b494e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774b494e",
  null
  
)

export default component.exports